// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title-group[data-v-593ae64a] {\n  margin-top: 20px;\n  margin-bottom: 10px;\n}\n.title-group[data-v-593ae64a]:first-child {\n  margin-top: 0px;\n}\n.title-group .title[data-v-593ae64a] {\n  margin: 0px;\n}\n.title-group .sub-title[data-v-593ae64a] {\n  margin: 0px;\n  color: #909399;\n  font-size: 10px;\n}", ""]);
// Exports
module.exports = exports;
